// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"980098bb","732":"4a2a939d","977":"9a31e2b7"}[chunkId] + ".chunk.js";
};